module.exports = __webpack_public_path__ + "media/images/konintodoke/other_services/services06-eba9016a14bea4894cd04d37c7caf4e9.jpg";